module.exports = __webpack_public_path__ + "img/fallback-pdf.a44fcc75.jpg";